import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScFaqPage = styled.div`
  & > div {
    & > h2 {
      text-align: center;
      justify-content: center;
      margin-bottom: 16px;
    }
    & > .text {
      font-size: 16px;
      line-height: 24px;
      color: #fff;
      margin: 0 auto 64px;
      text-align: center;
      max-width: 700px;
      @media (${device.desktop}) {
        max-width: 555px;
      }
    }
    .content {
      width: 100%;
      max-width: 900px;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      & > div:nth-child(1) {
        margin-bottom: 28px;
      }
      @media (${device.tablet}) {
        & > .category {
          margin-bottom: 16px;
        }
        & > .category:not(:first-child) {
          margin-top: 8px;
        }
        & > .questions {
          & > .question:not(:last-child) {
            margin-bottom: 8px;
          }
        }
      }
    }
  }
`;

export const ScQuestionAnswer = styled.div`
  max-width: 830px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  & > .questions {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;
